"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _reactBicycle = require("react-bicycle");
var _react = _interopRequireWildcard(require("react"));
var _collapse = _interopRequireDefault(require("../../../../core/collapse"));
var _button = _interopRequireDefault(require("../../../../core/button"));
var _submit = _interopRequireDefault(require("../../../../core/submit"));
var _rowConfig = _interopRequireDefault(require("../../../../core/row-config"));
var _formGroup = _interopRequireDefault(require("../../../../core/form-group"));
var _label = _interopRequireDefault(require("../../../../core/label"));
var _col = _interopRequireDefault(require("../../../../core/col"));
var _selectCode = _interopRequireDefault(require("../../../../core/select-code"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
const initialState = {
  isOpened: false,
  tierRef: null
};
var _ref = /*#__PURE__*/_react.default.createElement("p", {
  className: "lead"
}, "After adding a new division you will need to regenerate the races on the next tab.");
var _ref2 = /*#__PURE__*/_react.default.createElement(_label.default, null, "Division*");
class AddDivision extends _react.Component {
  constructor(...args) {
    super(...args);
    _defineProperty(this, "state", initialState);
    _defineProperty(this, "_toggleOpened", () => {
      this.setState({
        isOpened: !this.state.isOpened
      });
    });
    _defineProperty(this, "_onCancel", () => {
      this.setState(initialState);
    });
    _defineProperty(this, "_onSubmit", e => {
      e.preventDefault();
      this.props.onAddDivision(this.props.competitionID, this.state.tierRef).then(() => {
        this.setState(initialState);
      });
    });
    _defineProperty(this, "_setValue", value => {
      this.setState({
        tierRef: value
      });
    });
  }
  render() {
    return /*#__PURE__*/_react.default.createElement("div", null, /*#__PURE__*/_react.default.createElement("div", {
      style: {
        marginBottom: 8
      }
    }, /*#__PURE__*/_react.default.createElement(_button.default, {
      onClick: this._toggleOpened
    }, this.state.isOpened ? 'Hide' : 'Add Division')), /*#__PURE__*/_react.default.createElement(_collapse.default, {
      isOpened: this.state.isOpened
    }, /*#__PURE__*/_react.default.createElement("div", {
      className: "card card-block"
    }, _ref, /*#__PURE__*/_react.default.createElement("form", {
      onSubmit: this._onSubmit
    }, /*#__PURE__*/_react.default.createElement(_rowConfig.default, {
      columns: [{
        sm: 4,
        md: 3
      }, {
        sm: 8,
        md: 9
      }]
    }, /*#__PURE__*/_react.default.createElement(_formGroup.default, null, _ref2, /*#__PURE__*/_react.default.createElement(_col.default, null, /*#__PURE__*/_react.default.createElement(_selectCode.default, {
      yearID: this.props.competitionYearID,
      lookup: "DefaultTiers",
      value: this.state.tierRef,
      onChange: this._setValue,
      clearable: false,
      required: true
    })))), /*#__PURE__*/_react.default.createElement(_submit.default, {
      disabled: !this.state.tierRef
    }, "Add Division"), /*#__PURE__*/_react.default.createElement(_button.default, {
      onClick: this._onCancel
    }, " Cancel")))));
  }
}

// *******************************************************************************
// Data and actions
// *******************************************************************************
_defineProperty(AddDivision, "displayName", 'AddDivision');
var _default = exports.default = (0, _reactBicycle.connect)(AddDivision, undefined, (client, props) => ({
  onAddDivision(competitionID, tierRef) {
    return client.update('CompetitionDivision.create', {
      competitionID,
      tierRef
    });
  }
}));